import React from 'react';
import { Typography } from '@mui/material';
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import momentFormat from '#component/map/mapbox/moment-format';
import measurementsIcon from '#component/icon/measurements';
import { getYoungestMetrics, getRangeMetrics } from '#component/device/helper';
import {
  AlertHeader,
  Header,
  Label,
  LocatedTimestampCnt,
  StyledDeviceIcon,
  StyledDivider,
  TempCnt,
  TimestampCnt,
  TooltipContainer
} from './styles';

/**
 * Renders device info, metrics, events etc.
 * Fetches device info data.
 */
const DeviceInfoTooltip = props => {
  const { device, account, meta } = props;
  const itemsToRender = device.metricsRange ?
    getRangeMetrics(device.metricsRange, device, account, meta.device) :
    getYoungestMetrics(device.metrics, account, ['temperature', 'humidity', 'battery'], true);

  const icon = meta.device?.find(m => m.name === device.type)?.icon;

  return (
    <TooltipContainer>
      {device.tempExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Temperature excursion
        </AlertHeader> : null}
      {device.humiExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Humidity excursion
        </AlertHeader> : null}
      {device.batExcursion ?
        <AlertHeader>
          <NotificationsActiveRoundedIcon />
          Battery excursion
        </AlertHeader> : null}
      {device.firstLocation ?
        <Header>
          <DoubleArrowRoundedIcon />
          First geo-position
        </Header> : null}
      {device.lastLocation ?
        <Header>
          <LocationOnRoundedIcon />
          Last geo-position
        </Header> : null}
      <Label>
        <StyledDeviceIcon icon={icon} />
        <Typography color="textSecondary">
          {device.title || device.uid}
        </Typography>
      </Label>
      {device.firstTimestamp ?
        <TimestampCnt color="textSecondary">
          First at:&nbsp;
          {momentFormat(device.firstTimestamp, account, 'dateTimePartial')}
          <br />
          Last at:&nbsp;
          {momentFormat(device.lastTimestamp, account, 'dateTimePartial')}
        </TimestampCnt> :
        <LocatedTimestampCnt color="textSecondary">
          Located here
          {' '}
          {momentFormat(device.timestamp, account, 'dateTimePartial')}
        </LocatedTimestampCnt>}
      <StyledDivider style={{ display: itemsToRender?.length ? 'block' : 'none' }} />
      {itemsToRender?.length ? itemsToRender.map(item => (
        <TempCnt
          component="div"
          key={item.identifier}
          alert={!!item.excursion}
          isLight={item.identifier === 'light'}
          isPressure={item.identifier === 'pressure'}
        >
          {measurementsIcon(item.identifier, device, item.value)}
          <span>
            {item.label ?? item.value}
            {item.unit}
          </span>
        </TempCnt>
      )) : null}
    </TooltipContainer>
  );
};

export default DeviceInfoTooltip;
